import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Autocomplete,
  TextField,
  Box,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { dispatch } from "app/store/store";
import {
  showHideSwitchAccountModal,
  switchToAccount,
  showHideSwitchUserModal,
  switchUser,
} from "app/store/slice/common-slice";

/***Temp Files** */
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { useTheme } from "@mui/material";
import { unwrapResult } from "@reduxjs/toolkit";
import { setAuthToken } from "@jumbo/services/auth/jwtAuth";
import SweetAlert from "./SweetAlert";

const SwitchUsersModal = (props) => {
  const Swal = useSwalWrapper();
  const ToastRef = useRef();
  const theme = useTheme();
  const sweetAlerts = (variant, message) => {
    const Toast = Swal.mixin({
      toast: true,
      position: "top",
      showConfirmButton: false,
      timer: 3000,
      timerProgressBar: true,
      //   onOpen: (toast) => {
      //     toast.addEventListener("mouseenter", Swal.stopTimer);
      //     toast.addEventListener("mouseleave", Swal.resumeTimer);
      //   },
    });

    Toast.fire({
      icon: variant,
      title: message,
      background: theme.palette.background.paper,
    });
  };

  const { openSwitchUserModal, authUserData } = useSelector(
    (state) => state.CommonReducer
  );

  let switchUsersList =
    authUserData?.switch_users_list?.length > 0
      ? authUserData?.switch_users_list
      : [];

  let sel_userid_Obj = {};
  for (var i = 0; i < switchUsersList.length; i++) {
    if (switchUsersList[i]["id"] == authUserData.user_id) {
      sel_userid_Obj = switchUsersList[i];
    }
  }

  // console.log("sel_userid_Obj:", sel_userid_Obj);

  //   const getAccountName = () => {
  //     let obj = globalAccountsList.find((o) => o.value == globalAccount);
  //     if (obj) {
  //       return obj;
  //     } else {
  //       return "";
  //     }
  //   };
  const [user, setUser] = React.useState("");
  useEffect(() => {
    setUser(sel_userid_Obj);
  }, [authUserData.user_id]);

  //   const changeSwitchAccountHandler = (value) => {
  //     setAccount(value);
  //   };

  const changeSwitchUserHandler = (value) => {
    setUser(value);
  };

  const switchUserHandler = () => {
    dispatch(switchUser({ user_id: user.id }))
      .then(unwrapResult)
      .then((res) => {
        if (res.data.success == true) {
          let resultData = res.data;
          setAuthToken(resultData?.access_token);
          window.location.href = "/home/dashboard";
        } else {
          // ToastRef.current.showSweetAlerts("error", res.data.message);
          sweetAlerts("error", res.data.message);
          setTimeout(() => {
            window.location.href = "/home/dashboard";
          }, 1000);
        }
      });
  };
  const closeModal = () => {
    dispatch(showHideSwitchUserModal(false));
    setUser(sel_userid_Obj);
  };
  return (
    <div>
      <Dialog
        open={openSwitchUserModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .css-nubafe-MuiPaper-root-MuiDialog-paper": {
            borderRadius: "15px",
          },
        }}
      >
        {/* <DialogTitle id="alert-dialog-title">
          {"Use Google's location service?"}
        </DialogTitle> */}
        <DialogContent
          sx={{
            width: { xs: "290px", sm: "400px", md: "400px", lg: "400px" },
            pt: "40px",
            pb: "20px",
          }}
        >
          {/* <FormControl sx={{ width: "100%" }}> */}

          <Box>
            <Autocomplete
              clearOnEscape
              disableClearable
              id="global_user_id"
              options={switchUsersList}
              getOptionLabel={(option) =>
                option.name
                  ? option.name +
                    " [" +
                    option.username +
                    "] [ID:" +
                    option.id +
                    " ]"
                  : ""
              }
              sx={{
                width: "100%",
              }}
              isOptionEqualToValue={(option, value) => option.id === value.id}
              //   renderOption={(props, option) => (
              //     <li key={option.id} {...props}>
              //       {option.name + " [" + option.username + "]"}
              //     </li>
              //   )}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Switch User"
                  placeholder="Users"
                />
              )}
              onChange={(event, value) => changeSwitchUserHandler(value)}
              value={user}
            />
          </Box>

          {/* </FormControl> */}
        </DialogContent>
        <DialogActions sx={{ justifyContent: "center", pb: "30px" }}>
          <Button
            onClick={closeModal}
            variant="outlined"
            color="error"
            size="small"
          >
            Cancel
          </Button>
          <Button
            onClick={switchUserHandler}
            //autoFocus
            variant="contained"
            color="success"
            size="small"
          >
            Apply
          </Button>
        </DialogActions>
      </Dialog>
      <SweetAlert ref={ToastRef} />
    </div>
  );
};

export default SwitchUsersModal;
